import React, { useState } from 'react';
import warningAlert from '../../../assets/icons/alert-yellow-icon.svg';
import Button from '../../../components/Button';
import messages from './messages';
import { useIntl } from 'react-intl';
import NativeSelect from '../../../components/fields/NativeSelect';
import Input from '../../../components/fields/Input';
import BirthdayPicker from '../../../components/fields/BirthdayPicker/BirthdayPicker';
import Loading from '../../../components/Loading';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { validateDate } from '../../../utils/yupValidators';
import { jsonApiAxios } from '../../../services/api';
import {
  updatePerson,
  createPerson,
} from '../../../services/resources/persons';
import { createPassenger } from '../../../services/resources/passengers';

const relationshipToTypeMap = {
  category: 'dossierItemCategories',
  file: 'files',
  claim: 'claims',
  passenger: 'passengers',
};

const dossierItemSchema = {
  attributes: ['category', 'claim', 'file', 'passengers'],
  claim: {
    ref: 'id',
  },
  category: {
    ref: 'id',
  },
  file: {
    ref: 'id',
  },
  passengers: {
    ref: 'id',
  },
  typeForAttribute: (attribute: string | number) =>
    relationshipToTypeMap[attribute],
};

const validationSchema = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  date_of_birth: validateDate.required(),
});

const PassengerNotFound = (props: any) => {
  const {
    setShowWarning,
    passengers,
    fileId,
    claimId,
    setShowAlert,
    setAlertType,
    setUpdatedPassenger,
    setUpdatedPassengerId,
  } = props;
  const { formatMessage } = useIntl();
  const [selectedPassenger, setSelectedPassenger] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    passengers: '',
    first_name: '',
    last_name: '',
    date_of_birth: '',
  };
  const formatPassengers = () => {
    const pass = passengers?.map((passenger: any) => ({
      value: passenger?.passenger?.id,
      label: passenger?.passenger?.person?.first_name,
    }));
    pass.push({
      value: 'new',
      label: formatMessage(messages.addNewPassengerOption),
    });
    return pass;
  };

  const handleSelectPassenger = async (
    id: string | number,
    setFieldValue: any
  ) => {
    const findPassenger = passengers.find(
      (pass: any) => pass?.passenger?.id === id
    );
    setSelectedPassenger(findPassenger?.id ? findPassenger : {});
    setFieldValue(
      'first_name',
      findPassenger?.passenger?.person?.first_name || ''
    );
    setFieldValue(
      'last_name',
      findPassenger?.passenger?.person?.last_name || ''
    );
    setFieldValue(
      'date_of_birth',
      findPassenger?.passenger?.person?.date_of_birth || ''
    );
  };

  const postDossierItems = (passengerId: string | number) => {
    return jsonApiAxios.post(
      '/dossierItems',
      {
        claim: { id: claimId },
        category: { id: '2' },
        file: { id: fileId },
        passenger: { id: passengerId },
      },
      {
        schema: dossierItemSchema,
        type: 'dossierItems',
        headers: {},
      }
    );
  };

  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    if (selectedPassenger?.id) {
      await updatePerson({
        personId: selectedPassenger?.passenger?.person?.id,
        values,
      }).then((res: any) => {
        if (res?.id) {
          setAlertType('success');
          setUpdatedPassenger(true);
          setUpdatedPassengerId(selectedPassenger?.passenger?.id);
        } else {
          setAlertType('danger');
        }
      });
    } else {
      const { id: personId } = await createPerson({
        ...values,
      });

      const newPassenger = await createPassenger({
        claim: { id: claimId },
        person: { id: personId },
      });

      postDossierItems(newPassenger?.id).then((res: any) => {
        if (res?.id) {
          setAlertType('success');
          setUpdatedPassenger(true);
          setUpdatedPassengerId(newPassenger?.id);
        } else {
          setAlertType('danger');
        }
      });
    }
    setShowAlert(true);
    setShowWarning(false);
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div
          className="flex"
          style={{
            height: 'auto',
            background: '#fff9e7',
            borderLeft: 'solid',
            borderLeftColor: '#ff8f00',
            borderLeftWidth: '4px',
            marginTop: '3%',
          }}
        >
          <div style={{ marginLeft: '2%', marginTop: '5%' }}>
            <img width={70} src={warningAlert} alt={'info icon'} />
          </div>
          <div style={{ marginLeft: '3%', marginRight: '3%', marginTop: '3%' }}>
            <p style={{ marginTop: 0 }}>
              {formatMessage(messages.passengerNotFound)}
            </p>
            <div style={{ maxWidth: '90%', marginTop: '3%' }}>
              <Formik
                initialValues={initialValues}
                validateOnMount={true}
                validationSchema={validationSchema}
                // eslint-disable-next-line react/jsx-no-bind
                onSubmit={handleSubmit}
              >
                {({ values, isSubmitting, isValid, setFieldValue }) => {
                  return (
                    <Form>
                      <NativeSelect
                        className={'sm:w-full mb-5'}
                        name="passengers"
                        // eslint-disable-next-line react/jsx-no-bind
                        options={formatPassengers()}
                        label={messages.passengerLabel}
                        placeholder={messages.selectPassengerPlaceholder}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChangeCallback={(value: any) => {
                          handleSelectPassenger(value, setFieldValue);
                        }}
                      />

                      {values?.passengers?.length ? (
                        <div>
                          <Input
                            name="first_name"
                            label={messages.firstNameLabel}
                            className={'mb-5'}
                          />
                          <Input
                            name="last_name"
                            label={messages.lastNameLabel}
                            className={'mb-5'}
                          />
                          <BirthdayPicker
                            name="date_of_birth"
                            label={messages.dateOfBirthLabel}
                          />
                        </div>
                      ) : null}

                      <div
                        className="mt-15 flex sm:block justify-around"
                        style={{ maxWidth: '100%%', marginBottom: '5%' }}
                      >
                        <Button
                          theme="primary"
                          type="submit"
                          showIcon={false}
                          // width="full"
                          size="small"
                          disabled={!isValid || isSubmitting}
                        >
                          {values?.passengers === 'new'
                            ? formatMessage(messages.submitButton)
                            : formatMessage(messages.updateButton)}
                        </Button>
                        <Button
                          theme="secondary"
                          type="button"
                          // width="full"
                          size="small"
                          // eslint-disable-next-line react/jsx-no-bind
                          onClick={() => setShowWarning(false)}
                        >
                          {formatMessage(messages.cancelButton)}
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PassengerNotFound;
